import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid } from '@material-ui/core'

import { PhishingBanner, PhishingStatCard } from './components'

const PhishingDashboardCards = ({ indicators, onNewCampaign }) => {
  return (
    <Box>
      <PhishingBanner indicators={indicators} onNewCampaign={onNewCampaign} />
      <Box mt={3}>
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} md={6}>
            <PhishingStatCard
              label="Campanhas ativas no momento"
              value={indicators?.activeCampaignsCount ?? 0}
              subLabel="em andamento"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PhishingStatCard
              label="Total de campanhas criadas"
              value={indicators?.totalCampaigns ?? 0}
              subLabel="campanhas"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PhishingStatCard
              label="Taxa geral de cliques"
              value={`${indicators?.clickRate ?? 0}%`}
              subLabel="de participantes clicaram"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PhishingStatCard
              label="Cliques no link falso (consolidado)"
              value={indicators?.totalClicked ?? 0}
              subLabel="cliques totais"
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

PhishingDashboardCards.propTypes = {
  indicators: PropTypes.shape({
    activeCampaignsCount: PropTypes.number,
    totalCampaigns: PropTypes.number,
    clickRate: PropTypes.number,
    totalClicked: PropTypes.number,
  }),
  onNewCampaign: PropTypes.func,
}

export default PhishingDashboardCards
